var _image;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 3,
    y: 3,
    width: 19,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABGdBTUEAALGOfPtRkwAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAQKADAAQAAAABAAAAQAAAAABGUUKwAAABEElEQVR4Ae2ZMQ7CQAwEOUTHS/gB/6/4AS+hPhKkSFekWbmwWU+aSFEce3fnIiU35pyXzse1s/hdOwZAQHMHWALNAeAlyBJgCTR3oP0SuB0AfB7P0EfB/f06HnV63p5/ej3r4jbv2Hu3JwADshCs0hcCqiSRNQcEZDlfpS8EVEkiaw4IyHK+Sl8IqJJE1hwQkOV8lb5j2RsM/Q+oIkiYg/8Bu1m8AwRkLG+FAMtYBVEQIJhleeu6LxAS+If7Aj+9LIFQ7AbFEGAQYkgCBITsMyiGAIMQQxIgIGSfQTEEGIQYkgABIfsMitsTsO4LGOSpS2hPAAbo0HhVQIBXnroaCNA986qAAK88dTUQoHvmVfEFlQ0XedWmQKwAAAAASUVORK5CYII=",
    fill: "none",
    fillRule: "evenodd"
  })));
}

export default SvgFlag;